import { v1 as uuid } from "uuid";
import { getSoatOneStep } from '../../services/clientServices';
import {
  ERROR_ONESTEP_REGISTER,
  LOAD_ONESTEP_REGISTER,
  SUCCESS_ONESTEP_REGISTER,
  ACTION_ONESTEP_REGISTER,
  FORCE_STOPLOAD_ONESTEP_REGISTER,
} from '../types/oneStepTypes';

export const getRequestOneStep = (soatData) => {
  const formatPlaca = soatData.plate.replace('-', '');

  const request = {
    placa: formatPlaca,
    tipoDocumento: soatData.typeDoc,
    numeroDocumento: soatData.numDoc,
    correo: 'prueba@prueba.com',
    indPoliticaProtecDatPers: 'SI',
    indPoliticaEnvioComunic: 'NO',
    origen: 'consulta-soat',
    flgDataVeh: soatData.flgDataVeh,
  };
  return request;
};

export const userSaveDataOneStep  = (soatData) => {
  localStorage.setItem('SILENT_ONE_STEP', uuid());
  localStorage.setItem('USER_DATA_IN_HOST', JSON.stringify(getRequestOneStep(soatData)))
}

export const userActionOneStep = () => (dispatch) => {
  return dispatch({
      type: ACTION_ONESTEP_REGISTER,
  });
};

export const forceStopLoadingOneStep = (idTrx, soatData) => (dispatch) => {
  localStorage.setItem('ID_ONE_STEP', idTrx);
  localStorage.setItem('SILENT_ONE_STEP', uuid());
  localStorage.setItem('USER_DATA_IN_HOST', JSON.stringify(getRequestOneStep(soatData)));
  return dispatch({
    type: FORCE_STOPLOAD_ONESTEP_REGISTER,
  });
}

export const getDataSoatOneStep = async (data, dispatch) => {
  try {
    dispatch({
      type: LOAD_ONESTEP_REGISTER,
    });

    const resp = await getSoatOneStep(
      getRequestOneStep(data)
    );

    dispatch({
      type: SUCCESS_ONESTEP_REGISTER,
      payload: {
        idTrx: `${resp.payload?.idTrx||''}`,
        message: resp.payload.message,
        flgDataVeh: Boolean(resp.payload.flgDataVeh) || Boolean(resp.payload.flgClienteNoExiste)
      },
    });
  } catch (error) {
    dispatch({
      type: ERROR_ONESTEP_REGISTER,
      payload: {
        message: error.message
      }
    });
  }
};
